const baseStyle = {
  fontWeight: "semibold",
};

const sizes = {
  "5xl": {
    fontSize: ["6xl", null, "7xl"],
    lineHeight: "5.625rem",
    letterSpacing: "tight",
  },
  "4xl": {
    fontSize: ["5xl", null, "6xl"],
    lineHeight: "4.5rem",
    letterSpacing: "tight",
  },
  "3xl": {
    fontSize: ["4xl", null, "5xl"],
    lineHeight: "3.75rem",
    letterSpacing: "tight",
  },
  "2xl": {
    fontSize: ["3xl", null, "4xl"],
    lineHeight: "2.75rem",
    letterSpacing: "tight",
  },
  xl: {
    fontSize: ["2xl", null, "3xl"],
    lineHeight: "2.375rem",
  },
  lg: {
    fontSize: ["xl", null, "2xl"],
    lineHeight: "2rem",
  },
  md: {
    fontSize: ["lg", null, "xl"],
  },
  sm: {
    fontSize: ["sm", null, "lg"],
  },
  xs: {
    fontSize: ["xs", null, "md"],
  },
  heroTitle: {
    fontSize: ["2xl", "4xl", "4xl", "5xl"],
    lineHeight: [1.2, 1.1, 1, 1],
  },
};

export default {
  baseStyle,
  sizes,
};
